import {
  Breadcrumb as _Breadcrumb,
  BreadcrumbProps as _BreadcrumbProps,
} from 'antd'

type BreadcrumbProps = _BreadcrumbProps

export function Breadcrumb(props: BreadcrumbProps) {
  return <_Breadcrumb {...props} />
}
